import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import { Alert, AlertDescription } from "./ui/alert";
import { Users, Shield, Key } from "lucide-react";
import { useSharedPermissions } from "../contexts/PermissionsContext";
import { Auth0Administration } from "./Auth0Administration";
import { Auth0PermissionsMatrix } from "./Auth0PermissionsMatrix";
import { Auth0UserRolesMatrix } from "./Auth0UserRolesMatrix";
import { PowerBiIntegrations } from "./PowerBiIntegrations";
import { AiPromptSettings } from "./AiPromptSettings";

export function Settings() {
  const { isAdmin } = useSharedPermissions();
  const [activeTab, setActiveTab] = useState(() => new URLSearchParams(window.location.search).has('powerbi') ? 'integrations' : 'users');
  
  return (
    <div className="min-h-screen p-6">
      <div className="max-w-7xl mx-auto space-y-6">
        <div className="flex items-center gap-4">
          <div><h1 className="text-2xl font-semibold">Settings</h1><p className="text-muted-foreground">Manage users, roles, permissions, and integrations.</p></div>
        </div>
        {isAdmin ? (
          <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
            <TabsList className="flex h-auto flex-wrap justify-start">
              <TabsTrigger value="users"><Users className="h-4 w-4 mr-2" />Users</TabsTrigger>
              <TabsTrigger value="roles"><Shield className="h-4 w-4 mr-2" />Roles</TabsTrigger>
              <TabsTrigger value="permissions"><Key className="h-4 w-4 mr-2" />Permissions</TabsTrigger>
              <TabsTrigger value="matrix"><Shield className="h-4 w-4 mr-2" />Permissions Matrix</TabsTrigger>
              <TabsTrigger value="user_roles_matrix"><Users className="h-4 w-4 mr-2" />User Roles Matrix</TabsTrigger>
              <TabsTrigger value="ai_prompts">AI prompts</TabsTrigger>
              <TabsTrigger value="integrations"><Key className="h-4 w-4 mr-2" />Integrations</TabsTrigger>
            </TabsList>
            <TabsContent value="users"><Auth0Administration tab="users" /></TabsContent>
            <TabsContent value="roles"><Auth0Administration tab="roles" /></TabsContent>
            <TabsContent value="permissions"><Auth0Administration tab="permissions" /></TabsContent>
            <TabsContent value="matrix"><Auth0PermissionsMatrix /></TabsContent>
            <TabsContent value="user_roles_matrix"><Auth0UserRolesMatrix /></TabsContent>
            <TabsContent value="ai_prompts"><AiPromptSettings /></TabsContent>
            <TabsContent value="integrations"><PowerBiIntegrations /></TabsContent>
          </Tabs>
        ) : (
          <Alert><AlertDescription>Only administrators can manage users, roles, and permissions.</AlertDescription></Alert>
        )}
      </div>
    </div>
  );
}
